


import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { TO_CLIENT_URL } from "../../settings/APISetting";
import { sortByProp } from "../../settings/themeSettings";
import api from "../../config/axiosConfig";



export const fetchToClient = createAsyncThunk('fetch-toclient', async (page = 1) => {
    const response = await api.get(TO_CLIENT_URL);
    return response.data;
});




export const createToClient = (toClient, err, cb) => {
    api.post(TO_CLIENT_URL, toClient)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const updateToClient = (toClient, err, cb) => {
    api.put(`${TO_CLIENT_URL}/${toClient.id}`, toClient)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const deleteToClient = (id, err, cb) => {
    api.delete(`${TO_CLIENT_URL}/${id}`)
        .then((response) => {
            if (cb) cb(response);
        })
        .catch((error) => {
            if (err) err(error);
        });
}


const toClientSlice = createSlice({

    name: 'toClients',
    initialState: { 
        toClients: [], 
        toClientsFetchStatus: '',
        lastCreatedToClient: null // Pour le préchargement automatique
    },

    reducers: {
        addToClient: (state, action) => {
            state.toClients = [...state.toClients, action.payload].sort((a,b) => sortByProp(a,b,'libelle'));
            state.lastCreatedToClient = action.payload;
        },
        setLastCreatedToClient: (state, action) => {
            state.lastCreatedToClient = action.payload;
        },
        clearLastCreatedToClient: (state) => {
            state.lastCreatedToClient = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchToClient.fulfilled, (state, action) => {

            if (Array.isArray(action.payload)) {
                state.toClients = [...action.payload].sort((a, b) => sortByProp(a, b, 'libelle'));
            } else if (action.payload && action.payload['hydra:member']) {
                // Support Hydra/API Platform format just in case
                state.toClients = [...action.payload['hydra:member']].sort((a, b) => sortByProp(a, b, 'libelle'));
            } else {
                state.toClients = [];
                console.error("fetchToClient payload is not an array:", action.payload);
            }
            state.toClientsFetchStatus = 'success';
        }).addCase(fetchToClient.pending, (state, action) => {
            state.toClientsFetchStatus = 'loading';

        }).addCase(fetchToClient.rejected, (state, action) => {

            state.toClientsFetchStatus = 'error';

        });
    }


});
export const { addToClient, setLastCreatedToClient, clearLastCreatedToClient } = toClientSlice.actions;
export default toClientSlice;